import styled from '@emotion/styled';
import { oldCss, theme } from '../shared/theme';

export const GroupChildContainer = styled.div`
  height: 100%;
  ${oldCss.greyBorder};
  background-color: white;
  padding: ${theme.oldSpacing.xxs} ${theme.oldSpacing.s};
`;
